export const QCDashboardReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            return {...state, isLoading: true};
        case "RECEIVED_DATA":
            return {...state, isLoading: false, widgetDataMap: action.data.widgetDataMap || {}};
        case "ERROR":
            return {...state, isLoading: false, widgetDataMap: {}};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/commons/reducer/QCDashboardReducer.js